let selectedShipFrequency = 1;
let selectedProduct = null;
let selectedSellingPlan = null;
let isGift = false;
const MOST_EXPENSIVE_BOX = 44.99;

// get url param with the key of payg
const urlParams = new URLSearchParams(window.location.search);
// log the value of the payg param
const paygParam = urlParams.get('payg');

const isPayg = paygParam || window.isPayg;

document.addEventListener('DOMContentLoaded', function () {
  if (isPayg) {
    document
      .querySelector('.charge-frequency-container')
      .classList.add('payg-hide');

    document.querySelector('.fire-level-container').classList.add('payg-hide');
    document
      .querySelector('.progress-bar-section-container')
      .classList.add('payg-hide');

    // get the next hr element after the element with the class of shipping-frequency-container
    const hrElement = document.querySelector(
      '.shipping-frequency-container'
    ).nextElementSibling;
    hrElement.classList.add('payg-hide');
  }
});

function handleChargeFrequencyClick(chargeFrequencyEl, isFirstLoad = false) {
  // scroll .shipping-frequency-container into view
  const shippingFrequencyContainer = document.querySelector(
    '.shipping-frequency-container'
  );
  if (!isFirstLoad) {
    shippingFrequencyContainer.scrollIntoView({ behavior: 'smooth' });
  }
  const chargeFrequencyElement = isFirstLoad
    ? chargeFrequencyEl
    : chargeFrequencyEl.target;
  if (chargeFrequencyElement.classList.contains('btn-selected')) return;
  const selected = document.querySelectorAll(
    '.charge-frequency-container .btn-selected'
  );
  selected.forEach(function (element) {
    element.classList.remove('btn-selected');
  });

  selectedProduct = chargeFrequencyElement.dataset.productId;
  selectedSellingPlan = chargeFrequencyElement.dataset.sellingPlan;
  const productPrice = chargeFrequencyElement.dataset.productPrice;
  const chargeFrequency = chargeFrequencyElement.dataset.chargeFrequency;
  document.querySelector('#product-price').innerHTML = productPrice;
  document.querySelector('.frequency-message').classList.remove('d-none');
  document.querySelector('.fire-level-container').classList.remove('d-none');
  document.querySelector('#message-shipments').innerHTML =
    chargeFrequency / selectedShipFrequency === 1
      ? ' 1 box'
      : ` ${chargeFrequency / selectedShipFrequency} boxes`;
  document.querySelector('#message-charges').innerHTML = chargeFrequency;

  const pricePerBox = parseFloat(
    (parseFloat(productPrice.replace('$', '')) *
      Number(selectedShipFrequency)) /
      Number(chargeFrequency)
  ).toFixed(2);

  document.querySelector(
    '#product-price-per-box'
  ).innerHTML = `($${pricePerBox} per box)`;
  chargeFrequencyElement.classList.add('btn-selected');

  document.querySelector('#primary-add-to-cart').classList.remove('disabled');
  document
    .querySelector('#primary-add-to-cart-gift')
    .classList.remove('disabled');

  const savingsPerBox = MOST_EXPENSIVE_BOX - pricePerBox;

  document.querySelector(
    '#savings-per-box'
  ).innerHTML = `($${savingsPerBox} per box)`;
  const totalSavingsAmountEl = document.querySelector('#total-savings-amount');
  if (totalSavingsAmountEl) {
    totalSavingsAmountEl.innerHTML = `$${
      savingsPerBox * (chargeFrequency / selectedShipFrequency)
    }`;
  }

  const savingsImages = document.querySelectorAll('.fire-level');
  savingsImages.forEach(function (savingsImage, index) {
    if (savingsPerBox === 0) {
      if (index > 0) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 5) {
      if (index > 1) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 6) {
      if (index > 2) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 7) {
      if (index > 3) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox > 7) {
      savingsImage.classList.add('lit');
    }
  });
}

function handleShipFrequencyClick(frequencyEl, isFirstLoad = false) {
  // scroll .shipping-frequency-container into view
  const shippingFrequencyContainer = document.querySelector(
    '.shipping-frequency-container'
  );
  if (!isFirstLoad) {
    shippingFrequencyContainer.scrollIntoView({ behavior: 'smooth' });
  }
  const frequencyElement = isFirstLoad ? frequencyEl : frequencyEl.target;

  if (frequencyElement.classList.contains('btn-selected')) return;

  document.querySelector('#product-price').innerHTML =
    'Select options to see price';
  document.querySelector('.fire-level-container').classList.add('d-none');
  document.querySelector('.frequency-message').classList.add('d-none');
  document.querySelector('#product-price-per-box').innerHTML = '';
  selectedProduct = null;
  document.querySelector('#primary-add-to-cart').classList.add('disabled');
  document.querySelector('#primary-add-to-cart-gift').classList.add('disabled');

  const selected = document.querySelectorAll('.btn-selected');
  selected.forEach(function (element) {
    element.classList.remove('btn-selected');
  });

  frequencyElement.classList.add('btn-selected');

  selectedShipFrequency = frequencyElement.dataset.shipFrequency;
  hideProductsByFrequency(selectedShipFrequency);

  if (isFirstLoad || isPayg) {
    let firstChargeFrequency;
    if (isPayg) {
      firstChargeFrequency = document.querySelector(
        `[data-charge-frequency="${selectedShipFrequency}"][data-ship-frequency-product="${selectedShipFrequency}"]`
      );
    } else {
      firstChargeFrequency = document.querySelector(
        `[data-ship-frequency-product="${selectedShipFrequency}"]`
      );
    }
    handleChargeFrequencyClick(firstChargeFrequency, true);
  }
}

function hideProductsByFrequency(frequency) {
  const products = document.querySelectorAll('[data-ship-frequency-product]');
  products.forEach(function (product) {
    if (product.dataset.shipFrequencyProduct != frequency) {
      product.classList.add('d-none');
    } else {
      product.classList.remove('d-none');
    }
  });
}

const frequencies = document.querySelectorAll('[data-ship-frequency]');
frequencies.forEach(function (frequencyEl) {
  const frequency = frequencyEl.dataset.shipFrequency;
  const frequencyPriceEls = document.querySelectorAll(
    `[data-ship-frequency-product="${frequency}"]`
  );

  Array.from(frequencyPriceEls).forEach(function (productButton, index) {
    const chargeFrequency = productButton.dataset.chargeFrequency;
    const frequencyPrice =
      (parseFloat(productButton.dataset.productPrice.replace('$', '')) *
        Number(frequency)) /
      Number(chargeFrequency);

    // set price data on charge frequency buttons
    frequencyPriceEls[index].querySelector('.price-per-box').innerHTML =
      parseFloat(frequencyPrice.toFixed(2));
    if (MOST_EXPENSIVE_BOX - parseFloat(frequencyPrice.toFixed(2)) > 0) {
      frequencyPriceEls[index].querySelector(
        '.savings-per-box'
      ).innerHTML = `save $${
        MOST_EXPENSIVE_BOX - parseFloat(frequencyPrice.toFixed(2))
      } / box`;
    }

    return parseFloat(frequencyPrice.toFixed(2));
  });

  frequencyEl.addEventListener('click', handleShipFrequencyClick);
});

const chargeFrequencies = document.querySelectorAll('[data-charge-frequency]');
chargeFrequencies.forEach(function (chargeFrequencyEl) {
  chargeFrequencyEl.addEventListener('click', handleChargeFrequencyClick);
});

document
  .querySelector('#primary-add-to-cart')
  .addEventListener('click', async function (e) {
    await addToCart(selectedProduct, selectedSellingPlan);
  });

document
  .querySelector('#primary-add-to-cart-gift')
  .addEventListener('click', async function (e) {
    await addToCart(selectedProduct, selectedSellingPlan, true);
  });

const optionalProductsContainers = document.querySelectorAll(
  '.optional-product-card'
);

const randomOptionalProduct =
  optionalProductsContainers[
    Math.floor(Math.random() * optionalProductsContainers.length)
  ];
randomOptionalProduct.classList.remove('d-none');

const optionalProducts = document.querySelectorAll(
  '.optional-product-add-to-cart'
);

optionalProducts.forEach(function (optionalProduct) {
  optionalProduct.addEventListener('click', async function () {
    ghjg;
    await addToCart(optionalProduct.dataset.productId);
  });
});

async function addToCart(productId, sellingPlan = null, isGift = false) {
  const body = {
    id: productId,
    quantity: 1,
    properties: {
      _is_subscription: true,
    },
  };

  if (!!sellingPlan) {
    body.selling_plan = sellingPlan;
  }

  if (isGift) {
    body.properties._is_gift = true;
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  await response.json();
}

const monthlyShipEl = document.querySelector('[data-ship-frequency="1"]');
handleShipFrequencyClick(monthlyShipEl, true);

const populateProgressBar = data => {
  const progress = document.querySelector('.progress-bar .progress');
  const progressWidth = Math.min((data.total_price / 25000) * 100, 100);
  progress.style.width = `${progressWidth}%`;

  if (data.total_price >= 25000) {
    document
      .querySelector('.progress-bar-section-container')
      .classList.add('complete');
  } else {
    document
      .querySelector('.progress-bar-section-container')
      .classList.remove('complete');
    const amountRemainingEl = document.querySelector('#amount-remaining');
    const amountRemaining = (25000 - data.total_price) / 100;
    amountRemainingEl.innerHTML = amountRemaining.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};

// when the page loads query the cart to populate the progress bar
// fetch('/cart.js')
//   .then(res => res.json())
//   .then(populateProgressBar);

// (function (ns, fetch) {
//   if (typeof fetch !== 'function') return;

//   ns.fetch = function () {
//     const response = fetch.apply(this, arguments);

//     response.then(res => {
//       if (
//         [
//           `${window.location.origin}/cart/add.js`,
//           `${window.location.origin}/cart/update.js`,
//           `${window.location.origin}/cart/change.js`,
//           `${window.location.origin}/cart/clear.js`,
//         ].includes(res.url)
//       ) {
//         res
//           .clone()
//           .json()
//           .then(data => {
//             if (Object.hasOwn(data, 'total_price')) {
//               populateProgressBar(data);
//             } else {
//               fetch('/cart.js')
//                 .then(res => res.json())
//                 .then(populateProgressBar);
//             }
//           });
//       }
//     });

//     return response;
//   };
// })(window, window.fetch);
